import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { GenericContentService } from '../generic-content.service';
import { ToastrService } from 'ngx-toastr';
import { IGenericContent } from '../igeneric-content';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-generic-content-detail',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './generic-content-detail.component.html',
  styleUrl: './generic-content-detail.component.scss'
})
export class GenericContentDetailComponent {

  genericContentForm: FormGroup;
  isEdit: boolean;
  constructor(
    private _formbuilder: FormBuilder,
    private dialogRef: MatDialogRef<GenericContentDetailComponent>,
    private toastr: ToastrService,
    private translate: TranslateService,
    private _genericContentService: GenericContentService,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { genericContent: IGenericContent, isEdit: boolean },
  ) {
    this.isEdit = _data?.isEdit;
  }

  ngOnInit(): void {
    this.genericContentForm = this._formbuilder.group({
      name: [this._data?.genericContent?.name, [Validators.required, Validators.maxLength(50)]],
    })
  }

  onSaveGenericContent() {
    const data = this.genericContentForm.getRawValue();
    this._genericContentService.createGenericContetnt(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('LABEL.GENERIC_CONTENT')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  onUpdateGenericContent() {
    const data = {
      id: this._data?.genericContent?.id,
      ...this.genericContentForm.getRawValue()
    };

    this._genericContentService.updateGenericContetnt(data).subscribe((response) => {

      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('LABEL.GENERIC_CONTENT')));
      } else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }

}
